<template>
  <div class="app-container">
    <div class="card" v-if="visibleShow">
      <div style="margin-bottom: 10px">
        <el-button type="primary" icon="el-icon-plus" @click="AddSubsidiary">
          添加子公司
        </el-button>
      </div>
    </div>
    <div class="mainContainer">
      <!-- 列表 -->
      <div class="table-container">
        <el-table v-loading="loading" :data="tableData" border height="100%">
          <el-table-column
            prop="groupCompanyName"
            label="所属集团"
            align="center"
          />
          <el-table-column prop="businessId" label="子公司ID" align="center" />
          <el-table-column
            prop="businessName"
            label="子公司名称"
            align="center"
          />
          <el-table-column prop="" label="共享接收审核" align="center">
            <template slot-scope="{ row }">
              {{ row.auditType == 1 ? "自动审核" : "人工审核" }}
            </template>
          </el-table-column>
          <el-table-column
            prop="defaultAuditor"
            label="默认审核人"
            align="center"
          />
          <!-- <el-table-column prop="" label="状态" align="center">
            <template slot-scope="{ row }">
              <el-switch
                v-model="row.status"
                active-color="#13ce66"
                inactive-color="#cccccc"
                :active-value="1"
                :inactive-value="0"
                @change="changeStatus(row)"
              />
            </template>
          </el-table-column> -->
          <el-table-column prop="operator" label="更新人" align="center" />
          <el-table-column prop="updateTime" label="最近更新" align="center" />
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="{ row }">
              <span class="btsed" @click="EditCompany(row)">编辑</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.currPage"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>
    <!-- 添加子公司 -->
    <el-dialog
      title="添加子公司"
      :visible.sync="dialogVisible"
      width="450px"
      :close-on-click-modal="false"
    >
      <div style="margin-bottom: 20px" class="futleds">
        子公司加入后将可以集团间共享资料
      </div>
      <div class="flex_centr">
        <div style="width: 100px; flex-shrink: 0">子公司ID：</div>
        <!-- <SelectQuery
          :form="AddItems"
          queryKey="keyword"
          placeholder="请输入子公司id编号"
          IDnams="businessId"
          labelKey="businessName"
          valueKey="id"
          urltxt="/customer/selectList?type=1"
          width="300px"
        /> -->
        <el-input v-model="AddItems.businessName" clearable />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="Onsure" :loading="btnloading">
          确 定
        </el-button>
      </span>
    </el-dialog>
    <!-- 编辑弹窗 -->
    <el-dialog
      title="编辑"
      :visible.sync="dialogEdit"
      width="450px"
      :close-on-click-modal="false"
    >
      <div>
        共享接收审核：
        <el-radio-group v-model="EditItems.auditType">
          <!-- <el-radio :label="1">自动审核</el-radio> -->
          <el-radio :label="2">人工审核</el-radio>
        </el-radio-group>
      </div>
      <div style="margin: 15px 0px" class="futle yeler">
        <span v-if="EditItems.auditType == 1">
          说明：子公司共享的客户资料将直接覆盖更新，无需人工审核</span
        >
        <span v-else>
          说明：子公司共享的客户资料，需人工审核通过后才会覆盖更新</span
        >
      </div>
      <div v-if="EditItems.auditType == 1" class="flex_centr">
        <div style="width: 80px">用户ID：</div>
        <el-input
          v-model="EditItems.defaultAuditor"
          clearable
          placeholder="请输入审核用户的ID编号"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogEdit = false">取 消</el-button>
        <el-button
          type="primary"
          @click="EditCompanySubmit"
          :loading="btnloading"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getCompanyList, //集团管理-子公司列表
  addCompany, //集团管理-添加集团公司子公司
  editCompany, //集团管理-编辑集团公司子公司
  statusCompany, //集团管理-启用禁用集团公司子公司
  getUserInfo, //获取登录用户信息
} from "@/api/appApi/appapi.js";
export default {
  name: "",
  data() {
    return {
      queryParams: {
        currPage: 1, // 页码
        pageSize: 10, //每页大小
      },

      total: 0,
      loading: false,
      tableData: [], //列表

      btnloading: false, //按钮加载状态
      dialogVisible: false, //添加子公司弹窗
      AddItems: {
        businessName: "", //子公司名称
        businessId: "", //子公司ID
      },

      dialogEdit: false, //编辑弹窗
      EditItems: {
        id: "", //子公司id
        auditType: 2, //共享接收审核
        defaultAuditor: "", //默认审核人
      }, //编辑项

      visibleShow: false, //是否显示添加子公司弹窗
    };
  },

  async created() {
    let res = await getUserInfo();
    if (res.code == "000000") {
      if (res.content.businessName == "四川合纵药易购医药股份有限公司") {
        this.visibleShow = true;
      }
    }
    await this.getList();
  },
  methods: {
    /** 查询列表数据 */
    async getList() {
      this.loading = true;
      let res = await getCompanyList(this.queryParams);
      this.loading = false;
      if (res.code == "000000") {
        this.tableData = res.content.list;
        this.total = res.content.totalRecords;
      }
    },
    //查询按钮操作
    handleQuery() {
      this.queryParams.currPage = 1;
      this.getList();
    },
    // 重置
    handleReset() {
      Object.assign(this.queryParams, this.$options.data().queryParams);
      this.getList();
    },
    /** 添加子公司 */
    AddSubsidiary() {
      Object.assign(this.AddItems, this.$options.data().AddItems);
      this.dialogVisible = true;
    },
    /** 添加 */
    async Onsure() {
      if (!this.AddItems.businessName) {
        this.$message.error("请输入子公司名称");
        return;
      }
      this.btnloading = true;
      let res = await addCompany({
        businessName: this.AddItems.businessName,
        businessId: this.AddItems.businessName,
      });
      this.btnloading = false;
      if (res.code == "000000") {
        this.dialogVisible = false;
        this.$message.success(res.message);
        this.getList();
      }
    },
    /**  编辑 */
    EditCompany(row) {
      // Object.assign(this.EditItems, row);
      Object.assign(this.EditItems, this.$options.data().EditItems);
      this.EditItems.id = row.id;
      this.EditItems.auditType = row.auditType;
      // this.EditItems.defaultAuditor = row.defaultAuditor;
      this.dialogEdit = true;
    },
    /** 编辑保存 */
    async EditCompanySubmit() {
      if (this.EditItems.auditType == 1) {
        if (!this.EditItems.defaultAuditor) {
          this.$message.error("请输入审核用户的ID编号");
          return;
        }
      }
      this.btnloading = true;
      let res = await editCompany(this.EditItems);
      this.btnloading = false;
      if (res.code == "000000") {
        this.dialogEdit = false;
        this.$message.success(res.message);
        this.getList();
      }
    },
    /** 状态修改 */
    async changeStatus(row) {
      let res = await statusCompany({
        id: row.id,
      });
      if (res.code == "000000") {
        this.$message.success(res.message);
        this.getList();
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
